import {
  Box,
  BoxProps,
  chakra,
  ListItem,
  OrderedList,
  Text,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { stylesByLevel } from "./styles-by-level";
import { useScrollSpy } from "./use-scroll-spy";
interface PostHeading {
  level: "h1" | "h2" | "h3" | "h4" | "h5";
  text: string;
  id: string;
}
export interface PostTableOfContentsProps extends BoxProps {
  headings: PostHeading[];
}

export function PostTableOfContents(
  props: PropsWithChildren<PostTableOfContentsProps>,
) {
  const { headings, children, ...rest } = props;
  const activeId = useScrollSpy(
    headings.map(({ id }) => `[id="${id}"]`),
    {
      rootMargin: "0% 0% -24% 0%",
    },
  );

  return (
    <aside>
      <Box
        as="nav"
        aria-labelledby="toc-title"
        width="18rem"
        flexShrink={0}
        position="sticky"
        pr="4"
        top="0"
        left="0"
        fontSize="sm"
        alignSelf="start"
        sx={{ overscrollBehavior: "contain" }}
        {...rest}
      >
        <Text
          as="h2"
          id="toc-title"
          textTransform="uppercase"
          fontWeight="bold"
          fontSize="xs"
          color={"gray.700"}
          letterSpacing="wide"
        >
          Table of Contents
        </Text>
        <OrderedList
          spacing={1}
          ml="0"
          mt="4"
          styleType="none"
          maxHeight="calc(100vh - 18rem)"
          overflowY="auto"
          apply="styles.wrapperStyles.scrollable"
        >
          {headings.map(({ id, text, level }) => (
            <ListItem key={id} title={text} ml={stylesByLevel(level).ml}>
              <chakra.a
                py="0.25"
                display="block"
                fontWeight={id === activeId ? "bold" : "medium"}
                href={`#${id}`}
                aria-current={id === activeId ? "location" : undefined}
                color={"gray.600"}
                _hover={{
                  color: "gray.900",
                }}
                fontSize="xs"
              >
                {text}
              </chakra.a>
            </ListItem>
          ))}
        </OrderedList>
        {children}
      </Box>
    </aside>
  );
}
